import { postData, getData, putData } from '../axiosServices'

export const getAllCoeLabs = async (coe_Id,labType="",semester="",year="") => {
    let url = `labs/getAllOfCoe/${coe_Id}?semester=${semester}&lab_type=${labType}&enrolment_year=${year}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url, { headers });
};
export const getLevelCount = async (moduleId,topicId) => {
    let url = `practices/${moduleId}/topic/${topicId}/levelcount`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url, { headers });
};
export const getAllDailyPractice = (coeID, labID) => {
    const url = `labdailypractices/coe/${coeID}/lab/${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const addDailyPractice = (coeID, labID, makerPlanID, moduleID, topicID, data) => {
    const url = `labdailypractices/coe/${coeID}/lab/${labID}/makerplan/${makerPlanID}/module/${moduleID}/topic/${topicID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const UpdateDailyPractice = (practiceID, coeID, labID, makerPlanID, moduleID, topicID, data) => {
    const url = `labdailypractices/${practiceID}/coe/${coeID}/lab/${labID}/makerplan/${makerPlanID}/module/${moduleID}/topic/${topicID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return putData(url, data, { headers });
}
export const disableDailyPractice = (practiceID, coeID, labID, makerPlanID, moduleID, topicID) => {
    const url = `labdailypractices/${practiceID}/coe/${coeID}/lab/${labID}/makerplan/${makerPlanID}/module/${moduleID}/topic/${topicID}/isdisable`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return putData(url, {}, { headers });
}
export const getDailyPracticeQR = (practiceID ) => {
    const url = `labdailypractices/${practiceID}/qrcode`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url,{}, { headers,responseType: 'blob'});
}